import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ArticleIntro } from './components/ArticleIntro';
import { MythSection } from './components/MythSection';
import { ProductSection } from './components/ProductSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { ComparisonTable } from './components/ComparisonTable';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'Haar & Kopfhaut – Alles für deine Haare';
  }, []);
  return <div className="min-h-screen flex flex-col font-body text-charcoal bg-cream" data-id="element-0">
      <Header data-id="element-1" />

      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <ArticleIntro data-id="element-4" />
        <MythSection number={1} title={'\u201EJe mehr Inhaltsstoffe, desto besser das Produkt.\u201C'} intro={<>
              <p data-id="element-6">
                Du kennst sie. Flaschen mit 15, 20, manchmal 30 aktiven
                Inhaltsstoffen – Rosmarin, Biotin, Koffein, Sägepalme, Keratin,
                Arganöl, Kollagen, Peptide – alles aufgetürmt wie eine
                Absicherung gegen das Scheitern.
              </p>
              <p data-id="element-7">Mehr Komplexität muss doch mehr Wirkung bedeuten. Oder?</p>
            </>} truth={<>
              <p data-id="element-8">
                Eine lange Inhaltsstoffliste auf einem oberflächlichen Öl bleibt
                trotzdem ein oberflächliches Öl. Was viel mehr zählt als das,
                was in einem Produkt steckt, ist: Wo wird es aufgetragen? Wie
                gut wird es aufgenommen? Und ist die Formel für die Kopfhaut und
                die Haarwurzelzone konzipiert – oder für die Längen und den
                Glanz?
              </p>
              <p data-id="element-9">
                Viele der am stärksten beworbenen Produkte auf dem Markt sind
                hauptsächlich für den mittleren Bereich und die Spitzen
                formuliert. Sie verbessern Textur, Geschmeidigkeit und Glanz –
                das sind echte Vorteile – aber sie tun kaum etwas für die Zone,
                in der sichtbares Dünnerwerden zuerst auffällt: die
                Scheitellinie, die Kopfmitte, die Schläfen und die
                Haarwurzelzone.
              </p>
              <p className="font-semibold" data-id="element-10">
                Komplexität an der falschen Stelle ist keine Wirksamkeit. Es ist
                Ablenkung.
              </p>
            </>} quote="Ich hab eines mit 27 Inhaltsstoffen gekauft. Mein Haar fühlte sich einen Tag lang gepflegt an. Mein Scheitel sah genauso aus wie vorher." quoteAuthor="Amanda, 38 – Forum-Kommentar" imageSrc="https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=800&q=80" imageAlt="Bottles of various hair oils and serums" data-id="element-5" />
        <MythSection number={2} title={'\u201EWenn Rosmarinöl nicht gewirkt hat, wirkt nichts Natürliches.\u201C'} intro={<>
              <p data-id="element-12">
                Rosmarinöl hatte ein bemerkenswertes paar Jahre. Eine weit
                geteilte Studie zeigte, dass es in einem klinischen Versuch mit
                2%igem Minoxidil vergleichbar war – und die Beauty-Welt griff
                das auf. Plötzlich massierte jede Frau mit Haarausfall reines
                Rosmarinessenziöl in die Kopfhaut und wartete auf die
                Verwandlung.
              </p>
              <p data-id="element-13">
                Für die meisten blieb sie aus. Und daraus zog man den Schluss:
                Natürlich wirkt nicht.
              </p>
            </>} truth={<>
              <p data-id="element-14">
                Die Studie ist real, und das Interesse an dem Inhaltsstoff ist
                berechtigt. Aber was das virale Gespräch weggelassen hat, war
                der Kontext: wie das Produkt aufgetragen wurde, wie oft, in
                welcher Konzentration – und ob jemand es überhaupt richtig auf
                der Kopfhaut angewendet hat, anstatt nur auf den Längen.
              </p>
              <p data-id="element-15">
                Die meisten Frauen, die Rosmarinöl versucht und aufgehört haben,
                haben es nicht falsch gemacht, weil sie unachtsam waren. Sie
                haben es falsch gemacht, weil das Produkt, das sie gekauft
                haben, ein Allzweck-Haaröl war – aus der Flasche gegossen, über
                das Haar verteilt – und fettig, schwer und frustrierend
                hinterlassen hat.
              </p>
              <p data-id="element-16">
                Rosmarin, der auf deine Längen gegossen wird, ist nicht dasselbe
                wie eine gezielte Kopfhaut-Routine mit einem Pipettenapplikator,
                der direkt in die Haarwurzelzone eingearbeitet wird und vor dem
                Waschen einziehen kann.
              </p>
              <p className="font-semibold" data-id="element-17">
                Natürliche Inhaltsstoffe können absolut Teil einer sinnvollen
                Routine sein. Die Variable ist nicht der Inhaltsstoff – sondern
                das Auftragssystem und die Konsequenz.
              </p>
            </>} quote="Ich hab Rosmarin drei Monate lang versucht. Es hat nur meine Ansätze fettig gemacht. Mir war nicht klar, dass ich es komplett falsch angewendet hab." quoteAuthor="Melanie, 33 – Produktbewertung" data-id="element-11" />
        <MythSection number={3} title={'\u201EHaarausfall bedeutet, dass du Medikamente brauchst.\u201C'} intro={<>
              <p data-id="element-19">
                Minoxidil ist die am häufigsten empfohlene Behandlung bei
                weiblichem Haarausfall – und für die Frauen, bei denen es wirkt,
                hilft es tatsächlich. Das ist es wert, anzuerkennen.
              </p>
              <p data-id="element-20">
                Aber irgendwann bildete sich eine kulturelle Abkürzung: dünner
                werdendes Haar = braucht ein Medikament. Und für viele Frauen –
                besonders jene mit postpartalem Haarausfall, stressbedingtem
                Ausfall oder früh einsetzender diffuser Ausdünnung – bringt
                diese Sichtweise sie direkt zur härtesten Option, obwohl ihre
                Situation das gar nicht erfordert.
              </p>
            </>} truth={<>
              <p data-id="element-21">
                Nicht jeder Haarausfall ist gleich – und nicht jeder ist erblich
                bedingter Haarausfall nach Muster.
              </p>
              <p data-id="element-22">
                Postpartaler Haarausfall – ein Telogen-Effluvium, das durch den
                Hormonwechsel nach der Geburt ausgelöst wird – ist meist
                vorübergehend. Stressbedingter Ausfall, oft durch eine
                belastende Phase, Krankheit oder Ernährungsveränderung
                ausgelöst, kann sich auflösen, wenn die Ursache wegfällt. Frühe
                diffuse Ausdünnung bei jüngeren Frauen ist oft ein Zeichen, dass
                die Kopfhaut belastet ist – nicht, dass die Haarfollikel
                unwiederbringlich miniaturisieren.
              </p>
              <p data-id="element-23">
                Für diese Frauen ist eine unterstützende kopfhaut-zentrierte
                Routine keine minderwertige Option. Sie kann genau das richtige
                Maß an Unterstützung sein: etwas, das das Kopfhaut-Milieu
                pflegt, die sichtbaren Zeichen des Ausfalls reduziert und die
                Routine nachhaltig genug macht, um wirklich dran zu bleiben.
              </p>
              <p className="font-semibold" data-id="element-24">
                Direkt zu einem pharmazeutischen Dauerpräparat zu greifen, weil
                die Branche suggeriert, das sei die einzig ernsthafte Option,
                kann bedeuten, den Schritt zu überspringen, der vielleicht
                ausgereicht hätte.
              </p>
            </>} quote="Drei Monate nach der Geburt – alles fiel aus. Mein Arzt sagte, es würde sich legen. Aber ich brauchte trotzdem etwas, das sich in der Zwischenzeit wirklich anfühlt." quoteAuthor="Nina, 31 – Reddit" imageSrc="https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80" imageAlt="Woman looking thoughtfully in the mirror" data-id="element-18" />
        <MythSection number={4} title={'\u201EWenn kein Nachwachsen sichtbar ist, wirkt es nicht.\u201C'} intro={<>
              <p data-id="element-26">
                Dieser Mythos erzeugt enorme Frustration – und treibt die
                meisten frühzeitigen Abbrüche an.
              </p>
              <p data-id="element-27">
                Eine Frau beginnt eine neue Routine. Zwei Wochen vergehen. Sie
                zieht ihr Haar zurück und studiert den Scheitel im Spiegel. Sie
                sieht keine neuen Haare wachsen. Sie entscheidet: Es wirkt
                nicht. Sie hört auf. Sie probiert das nächste Ding.
              </p>
              <p data-id="element-28">
                Der Kreislauf wiederholt sich. Jedes Mal ist das Zeitfenster
                konsequenter Anwendung kürzer, als es dauern würde, eine
                sichtbare Veränderung zu sehen. Und sie schlussfolgert –
                verständlicherweise – dass nichts funktioniert.
              </p>
            </>} truth={<>
              <p data-id="element-29">
                Die ersten Zeichen, dass eine kopfhaut-zentrierte Routine etwas
                bewirkt, sind kein Nachwachsen. Sie zeigen sich früher – und
                anders.
              </p>
              <p className="font-semibold mt-4 mb-2" data-id="element-30">
                Was Frauen zuverlässig zuerst berichten:
              </p>
              <ul className="list-disc pl-5 space-y-2 mb-4" data-id="element-31">
                <li data-id="element-32">
                  Weniger Haare in der Bürste, auf dem Badezimmerboden, im
                  Duschablauf
                </li>
                <li data-id="element-33">
                  Eine Kopfhaut, die sich weniger trocken, angespannt oder
                  gereizt anfühlt
                </li>
                <li data-id="element-34">
                  Mehr Selbstvertrauen an der Haarwurzelzone – Haar, das voller
                  und getragener aussieht
                </li>
                <li data-id="element-35">
                  Babyhaare, die an der Haarlinie oder den Schläfen erscheinen –
                  fein, weich und leicht zu übersehen, wenn man nicht darauf
                  achtet
                </li>
              </ul>
              <p data-id="element-36">
                Das sind die Signale, die für viele Frauen nach 3–6 Wochen
                kommen – lange bevor eine sichtbare Dichte messbar ist. Wenn du
                nur auf eine dramatische Dichteveränderung wartest, gibst du
                auf, bevor du den Punkt erreichst, der sich lohnt.
              </p>
              <p className="font-semibold" data-id="element-37">
                Ordne neu, was als Fortschritt zählt. Weniger Haarausfall ist
                Fortschritt. Eine ruhigere Kopfhaut ist Fortschritt. Sein Haar
                zu stylen, ohne darüber nachzudenken, ist Fortschritt.
              </p>
            </>} quote="Ich hätte fast in Woche vier aufgehört. Dann bemerkte ich, dass meine Bürste morgens fast sauber war. Das war noch nie passiert. Ich hab weitergemacht." quoteAuthor="Sarah, 41 – Produktbewertung" data-id="element-25" />
        <MythSection number={5} title={'\u201EEine Ölroutine ruiniert deine Ansätze.\u201C'} intro={<>
              <p data-id="element-39">
                Das ist der Einwand, der mehr Haarroutinen zerstört als jeder
                andere – und den die Haaröl-Branche durch jahrelange schwere,
                fettige, schwer auswaschbare Formeln, die Ansätze drei Stunden
                nach dem Auftragen wie ungewaschen aussehen ließen, wirklich
                verdient hat.
              </p>
              <p data-id="element-40">
                Wenn du das kennst, weißt du das Gefühl. Du trägst das Öl mit
                guten Absichten auf. Am Vormittag sehen deine Ansätze flach und
                feucht aus. Du kannst das Haar nicht offen tragen. Du fühlst
                dich unwohl. Du wäschst es aus. Du benutzt das Produkt nie
                wieder.
              </p>
              <figure className="my-8 -mx-4 md:mx-0" data-id="element-41">
                <img src="https://cdn.magicpatterns.com/uploads/753kTNfEtWpsRZphyAXWqH/07_HaareImAbfluss-768x512-1.jpg" alt="Haare im Abfluss – ein bekanntes Bild für viele Frauen" className="w-full h-auto max-h-[500px] object-cover md:rounded-lg shadow-md" data-id="element-42" />
                <figcaption className="mt-3 px-4 md:px-0 text-sm italic text-charcoal/60" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-43">
                  {'So sah mein Abfluss fr\xFCher aus. Ihr kennt es bestimmt.'}
                </figcaption>
              </figure>
            </>} truth={<>
              <p data-id="element-44">
                Das Problem ist nicht das Öl. Es sind schwere, schlecht
                formulierte Öle, die zu großzügig aufgetragen werden, ohne klare
                Routinestruktur.
              </p>
              <p className="font-semibold mt-4 mb-2" data-id="element-45">
                Eine kopfhaut-zentrierte Routine, die funktioniert, ist anders
                aufgebaut:
              </p>
              <ul className="list-disc pl-5 space-y-2 mb-4" data-id="element-46">
                <li data-id="element-47">
                  Gezielte Anwendung an der Haarwurzelzone mit einem
                  Präzisionspipettenapplikator – nicht über die Längen gegossen
                </li>
                <li data-id="element-48">
                  Eine Formel, die einzieht statt zu beschichten – leicht genug,
                  um sie am Abend vor dem Waschen anzuwenden oder als
                  Pre-Wash-Behandlung
                </li>
                <li data-id="element-49">
                  Klare Anleitung zu Menge, Ort und Zeitpunkt – damit die
                  Erfahrung sauber bleibt und die Stylingroutine nicht
                  beeinträchtigt wird
                </li>
              </ul>
              <p className="font-semibold" data-id="element-50">
                Die besten kopfhaut-zentrischen Routinen sind solche, bei denen
                du wirklich dranbleibst, ohne zu opfern, wie dein Haar am selben
                Tag aussieht. Anwendbarkeit ist kein Nice-to-have. Sie ist der
                Grund, warum die meisten Menschen aufhören – und der Grund,
                warum die richtige Routine alles verändert.
              </p>
            </>} quote="Mir wurde erst bewusst, wie fettig mein altes Öl war, als ich gewechselt hab. Dieses hier kann ich abends auftragen – und am nächsten Morgen sieht mein Haar komplett normal aus." quoteAuthor="Franziska, 36 – verifizierte Bewertung" data-id="element-38" />

        <ProductSection data-id="element-51" />
        <TestimonialsSection data-id="element-52" />
        <FAQSection data-id="element-53" />
        <ComparisonTable data-id="element-54" />
        <CTASection data-id="element-55" />
      </main>

      <Footer data-id="element-56" />
    </div>;
}